<script setup>
  import { computed } from 'vue'

  import FieldValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/FieldValueRenderer.vue'
  import {
    fieldCommonProps,
    normalizeFieldExtraData,
  } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'

  const props = defineProps({
    modelValue: fieldCommonProps.modelValue,
    field: fieldCommonProps.field,
  })

  const selectedOptions = computed(() => {
    const extraData = normalizeFieldExtraData(props.field.extraData)
    const options = extraData?.options || []

    if (!Array.isArray(selectedOptions.value)) {
      return []
    }

    return options.filter(option => props.modelValue.includes(option.value))
  })

  const selectedOptionsLabel = computed(() => {
    if (!Array.isArray(selectedOptions.value)) {
      return null
    }

    return selectedOptions.value.map(option => option.label).join(', ')
  })
</script>

<template>
  <FieldValueRenderer :field="field">
    <template #label>
      <slot name="label">{{ field.key }}</slot></template
    >

    <slot>
      {{ selectedOptionsLabel }}
    </slot>
  </FieldValueRenderer>
</template>

<style lang="scss" scoped></style>
